import { RouteObject } from 'react-router-dom'
import List from './components/List'
import BidResult from './components/BidResult'
import Detail from './components/Detail'

const TendersModule: RouteObject = {
    path: 'tenders',
    children: [
        {
            path: '',
            element: <List />,
        },
        {
            path: ':tenderId',
            element: <Detail />,
        },
        {
            path: ':tenderID/bid-result',
            element: <BidResult />,
        },
    ],
}

export default TendersModule
